import { useState } from 'react';

export const useLocalState = (localItem, arr = false) => {
  const [loc, setState] = useState(
    arr ? JSON.parse(localStorage.getItem(localItem)) : localStorage.getItem(localItem)
  );

  const setLoc = (newItem, arr = false) => {
    localStorage.setItem(localItem, arr ? JSON.stringify(newItem) : newItem);
    setState(newItem);
  };

  return [loc, setLoc];
};

export const useSessionState = (sessItem, arr = false) => {
  const [sess, setState] = useState(
    arr ? JSON.parse(sessionStorage.getItem(sessItem)) : sessionStorage.getItem(sessItem)
  );

  const setSes = (newItem, arr = false) => {
    sessionStorage.setItem(sessItem, arr ? JSON.stringify(newItem) : newItem);
    setState(newItem);
  };

  return [sess, setSes];
};
